import {DishDetailsItem} from "@apps/dish/interfaces";

import {ObjectWithAnyProps} from "@globals/types/utilityTypes";

export type ReceiptLineItemType = {
  name: string;
  display_name: string;
  raw_value: number;
  value: string;
};

export type ReviewChoice = {
  id: number;
  choice: string;
};

export type OrderDishItem = {
  comment: string | null;
  count: number;
  display_name: string;
  id: number;
  menu: number;
  order: number;
  item: DishDetailsItem;
  rating: number;
  special_instructions: string;
  review_choices: ReviewChoice[];
} & ObjectWithAnyProps;

export type OrderResponseData = {
  auto_order: boolean;
  credit_applied: string;
  delivery_date: string;
  delivery_fee: string;
  driver_gratuity: number;
  id: number;
  line_items: ReceiptLineItemType[];
  location: ObjectWithAnyProps;
  meeting: string | null;
  name: string | null;
  order_datetime: string;
  order_items: OrderDishItem[];
  order_status: OrderStatus;
  promo_applied: string;
  status: string;
  subsidy: number;
  subtotal: string;
  tax: string;
  raw_total: number;
  total: string;
  user: ObjectWithAnyProps;
  meeting_id?: number;
};

export enum OrderStatus {
  Scheduled = "Scheduled",
  Cancelled = "Cancelled",
  InProgress = "In Progress",
}

export enum PaymentStatus {
  CompanyPaid = "Company Paid",
  CustomerPaid = "Customer Paid",
  CreditApplied = "Credit Applied",
}

export type OrderTransaction = {
  digits: number;
};

export const UPCOMING_ORDERS = "upcoming_orders";

export type OrderMeeting = {
  order: {
    dishes: ObjectWithAnyProps;
    guests: ObjectWithAnyProps;
  };
};
export enum OrdersType {
  Upcoming = "Upcoming",
  Past = "Past",
}
